import React from 'react';
import AdminHeader from '../../globals/Layout/Admin/AdminHeader';
import TTypeEvent from './Tables/TTypeEvent';
const TypeEvent: React.FC = () => {
    return (
        <div>
            <AdminHeader>Tipo de eventos</AdminHeader>  
            <TTypeEvent/>        
        </div>

    );
};


export default TypeEvent;